import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { throttle } from 'lodash'

import { loadState, saveState } from 'common/utils'
import { dashboardReducer } from 'features/dashboard'
import { examReducer } from 'features/exam'
import { filterReducer } from 'features/filter'

const preloadedState = loadState()

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  filters: filterReducer,
  exam: examReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  preloadedState,
})

store.subscribe(
  throttle(() => {
    saveState({
      dashboard: store.getState().dashboard,
    })
  }, 1000)
)

export type AppDispatch = typeof store.dispatch
export type AppRootState = ReturnType<typeof store.getState>
